import { Link } from 'react-router-dom';
import useSeo from '../hooks/useSeo';

export default function PrivacyPage() {
  useSeo({
    title: 'Privacy Statement',
    description: 'Read how TheScandal protects user anonymity and minimizes personal data collection.',
    path: '/privacy',
    keywords: [
      'privacy statement',
      'anonymous platform privacy',
      'no tracking policy',
      'no account registration',
      'data minimization',
    ],
  });

  return (
    <section className="legal-page">
      <h1>Privacy Statement</h1>
      <p className="legal-updated">Last updated: March 10, 2026</p>

      <p>TheScandal is designed to protect the identity of users who wish to share information.</p>
      <p>
        The platform does not require account registration and does not intentionally collect personal information
        about users.
      </p>
      <p>Usernames are automatically generated and are not linked to personal identities.</p>
      <p>
        Content such as posts, comments, images, and videos may be stored to maintain the functionality of the
        platform. However, TheScandal does not track users across sessions or store identifiable personal data.
      </p>
      <p>
        Users should avoid including personal identifying information in posts if they wish to remain anonymous.
      </p>
      <p>
        TheScandal is committed to protecting user privacy while maintaining a safe and responsible platform.
      </p>

      <p className="legal-back"><Link to="/">Back to Feed</Link></p>
    </section>
  );
}
